import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

function RequestFormFieldDisable(props) {
  const { formData, intl, name } = props;
  const translatedValue = intl.formatMessage({ id: formData });
  
  return (
    <div className="w-full py-[6px] pb-[7px]" data-cy={`${String(name).toLowerCase()}`}>
      <span className="block text-black/38 font-bold font-['Open_Sans'] text-[14px] leading-[19px]">
        {translatedValue}
      </span>
    </div>
  );
}

RequestFormFieldDisable.propTypes = {
  formData: PropTypes.string,
  intl: PropTypes.object.isRequired,
  name: PropTypes.string,
};

RequestFormFieldDisable.defaultProps = {
  formData: '',
  name: '',
};

export default injectIntl(RequestFormFieldDisable);
